export function videoPlayer(): void {
  const videoPlayers: NodeListOf<Element> = document.querySelectorAll('.js-video__item');
  if (videoPlayers) {
    for (const video of videoPlayers as any) {
      const playButton = video.querySelector('.js-video__player__button');
      const player = video.querySelector('.js-video__player');

      playButton.addEventListener('click', () => {
        playButton.classList.add('is-active');
        player.play();
      });
    }
  }
}
